import { Chip, type ChipProps } from '@mui/material';

export type WorkerType = 'percentage' | 'fixedRate' | 'adhoc';

interface WorkerTypeChipProps {
  type: WorkerType;
  size?: ChipProps['size'];
  /** Custom percentage value to display (e.g., 25.5 for "25.5% Split") */
  percentageValue?: number;
}

const chipConfig: Record<
  WorkerType,
  { label: string; color: ChipProps['color'] }
> = {
  percentage: { label: '% Split', color: 'secondary' },
  fixedRate: { label: 'Fixed Rate', color: 'info' },
  adhoc: { label: 'Ad-Hoc', color: 'warning' },
};

export function WorkerTypeChip({
  type,
  size = 'small',
  percentageValue,
}: WorkerTypeChipProps) {
  const config = chipConfig[type];

  const label =
    type === 'percentage' && percentageValue != null
      ? `${percentageValue.toFixed(1)}% Split`
      : config.label;

  return (
    <Chip
      label={label}
      color={config.color}
      size={size}
      variant="outlined"
      sx={{ height: size === 'small' ? 20 : 24 }}
    />
  );
}
